import React from 'react'
import isNil from 'lodash/fp/isNil'

class Modal extends React.Component {

  constructor(props) {
    super(props)

    this.handleKeyUp = this.handleKeyUp.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  componentDidMount() {
    window.addEventListener('keyup', this.handleKeyUp, false)
    document.addEventListener('click', this.handleOutsideClick, false)
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.handleKeyUp, false)
    document.removeEventListener('click', this.handleOutsideClick, false)
  }

  handleKeyUp(e) {
    const { onCloseRequest } = this.props
    const keys = {
      27: () => {
        e.preventDefault()
        onCloseRequest()
        window.removeEventListener('keyup', this.handleKeyUp, false)
      },
    }

    if (keys[e.keyCode]) {
      keys[e.keyCode]()
    }
  }

  handleOutsideClick(e) {
    const { onCloseRequest } = this.props
    if(!isNil(this.modal)) {
      if(!this.modal.contains(e.target)) {
        onCloseRequest()
        document.removeEventListener('click', this.handleOutsideClick, false)
      }
    }
  }

  render () {
    const { children } = this.props
    return (
      <div className='modalOverlay'>
        <div
          className='modal'
          ref={node => (this.modal = node)}
        >
          <div className='close-button-container'>
            <button
              type='button'
              className='close-button'
              onClick={() => this.props.onCloseRequest()}
            >
              ✖
            </button>
          </div>
            <div className='modalContent'>
              {children}
            </div>
        </div>
      </div>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/shared/modal.js